import request from '@/utils/request'

// 查询返现活动列表
export function listRebateActivity(query) {
  return request({
    url: '/played/rebate/activity/list',
    method: 'get',
    params: query
  })
}

// 查询返现活动详细
export function getRebateActivity(id) {
  return request({
    url: '/played/rebate/activity/' + id,
    method: 'get'
  })
}

// 新增返现活动
export function addRebateActivity(data) {
  return request({
    url: '/played/rebate/activity',
    method: 'post',
    data: data
  })
}

// 修改返现活动
export function updateRebateActivity(data) {
  return request({
    url: '/played/rebate/activity',
    method: 'put',
    data: data
  })
}

// 删除返现活动
export function delRebateActivity(id) {
  return request({
    url: '/played/rebate/activity/' + id,
    method: 'delete'
  })
}

// 查询活动任务列表
export function listRebateActivityTask(query) {
  return request({
    url: '/played/rebate/activity/task/list',
    method: 'get',
    params: query
  })
}

// 查询活动任务详细
export function getRebateActivityTask(id) {
  return request({
    url: '/played/rebate/activity/task/' + id,
    method: 'get'
  })
}

// 新增活动任务
export function addRebateActivityTask(data) {
  return request({
    url: '/played/rebate/activity/task',
    method: 'post',
    data: data
  })
}

// 修改活动任务
export function updateRebateActivityTask(data) {
  return request({
    url: '/played/rebate/activity/task',
    method: 'put',
    data: data
  })
}

// 删除活动任务
export function delRebateActivityTask(id) {
  return request({
    url: '/played/rebate/activity/task/' + id,
    method: 'delete'
  })
}
